'use strict';
module.exports = require('./DataViewLayoutOptions.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/dataviewlayoutoptions/index.js
// module id = 1523
// module chunks = 1